import { AddressDetails } from './types';

export const parseAddressComponents = (place: google.maps.places.PlaceResult): AddressDetails => {
  const addressDetails: AddressDetails = {
    address_line_1: '',
    address_line_2: '',
    address_line_3: '',
    city: '',
    country: '',
    country_code: '',
    full_address: place.formatted_address || '',
    latitude: 0,
    longitude: 0,
    postcode: '',
    state: '',
  };

  if (place.address_components) {
    const fieldTypeMapping: { [key in keyof AddressDetails]?: string[] } = {
      address_line_1: ['street_number', 'route', 'premise'],
      address_line_2: ['subpremise', 'neighborhood', 'sublocality', 'sublocality_level_1'],
      address_line_3: ['administrative_area_level_4', 'administrative_area_level_5', 'colloquial_area'],
      city: ['locality', 'postal_town', 'administrative_area_level_2', 'administrative_area_level_3'],
      country: ['country'],
      postcode: ['postal_code'],
      state: ['administrative_area_level_1'],
    };

    for (const component of place.address_components) {
      const types = component.types;

      if (fieldTypeMapping.address_line_1) {
        if (fieldTypeMapping.address_line_1.some((type) => types.includes(type))) {
          addressDetails.address_line_1 += component.long_name + ' ';
        }
      }

      if (fieldTypeMapping.address_line_2) {
        if (fieldTypeMapping.address_line_2.some((type) => types.includes(type))) {
          addressDetails.address_line_2 += component.long_name + ' ';
        }
      }

      if (fieldTypeMapping.address_line_3) {
        if (fieldTypeMapping.address_line_3.some((type) => types.includes(type))) {
          addressDetails.address_line_3 += component.long_name + ' ';
        }
      }

      if (!addressDetails.city && fieldTypeMapping.city) {
        if (fieldTypeMapping.city.some((type) => types.includes(type))) {
          addressDetails.city = component.long_name;
        }
      }

      if (!addressDetails.state && fieldTypeMapping.state) {
        if (fieldTypeMapping.state.some((type) => types.includes(type))) {
          addressDetails.state = component.long_name;
        }
      }

      if (!addressDetails.country && fieldTypeMapping.country) {
        if (fieldTypeMapping.country.some((type) => types.includes(type))) {
          addressDetails.country = component.long_name;
          addressDetails.country_code = component.short_name;
        }
      }

      if (!addressDetails.postcode && fieldTypeMapping.postcode) {
        if (fieldTypeMapping.postcode.some((type) => types.includes(type))) {
          addressDetails.postcode = component.long_name;
        }
      }
    }

    addressDetails.address_line_1 = addressDetails.address_line_1.trim();
    addressDetails.address_line_2 = addressDetails.address_line_2.trim();
    addressDetails.address_line_3 = addressDetails.address_line_3.trim();
  }

  if (place.geometry && place.geometry.location) {
    addressDetails.latitude = place.geometry.location.lat();
    addressDetails.longitude = place.geometry.location.lng();
  }

  return addressDetails;
};
